import { useEffect, useState } from "react";
import useDataFetch, { DataFetchOptionsType } from "../../hooks/useDataFetch";
import { getAPIresponse } from "./services";
import RenderLoading from "./partials/renderLoading";
import RenderGrid from "./partials/renderGrid";
import RenderError from "./partials/renderError";
import PageWrapper from "../../components/PageWrapper";

const Assessments = () => {
  // const [fetchOptions, setFetchOptions] = useState<DataFetchOptionsType>({
  //   error: { msg: "API Failed" },
  // });
  const [fetchOptions, setFetchOptions] = useState<DataFetchOptionsType>({});
  const { loading, data, error } = useDataFetch(getAPIresponse, fetchOptions);

  useEffect(() => {
    setFetchOptions({ requestId: new Date().getTime().toString() });
  }, []);

  if (loading) {
    return <RenderLoading />;
  }
  if (error) {
    return (
      <RenderError
        error={error}
        onRetry={() => {
          setFetchOptions({
            loading: true,
          });
          setTimeout(() => {
            setFetchOptions({ requestId: new Date().getTime().toString() });
          }, 1000);
        }}
      />
    );
  }

  if (data) {
    return (
      <PageWrapper>
        <RenderGrid data={data} setFetchOptions={setFetchOptions} />
      </PageWrapper>
    );
  }
};

export default Assessments;
